import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx} from '../../components/common/CustomBootstrap';
import JobRequests from './JobRequests';

class ZarinpalTransferGeneral extends Component {
  render() {
    const {t, userId} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="d-flex flex-row justify-content-between align-items-center text-large text-primary mb-5">
                {t('Zarinpal Transfers')}
              </CardTitle>
                  <JobRequests
                    userId={userId}
                    fetchBalances={this.fetchBalances}
                  />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(ZarinpalTransferGeneral);
